import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService {

  constructor(public auth: AuthService, public router: Router) { }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const expectedRole = route.data.expectedRole;

    const role = await this.auth.getRole();

    if (this.auth.isAuthenticated() && role.type === expectedRole) {
      // this.router.navigate(['settings/profile'])
      return true;
    } else {
      this.router.navigate(['login']);
      return false;
    }
  }
}
